import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { getMasterData, getSimMode } from 'src/api';
import { getAccountInfo, getMerchant } from 'src/api/user_profile';
import { store } from 'src/redux';
import { useAppSelector } from 'src/redux/hook';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { filterEnabledNodes } from 'src/utils';
import { v4 as uuidv4 } from 'uuid';
import './index.scss';
dayjs.extend(isBetween);

function Login() {
  const { masterData } = useAppSelector((state) => state.global);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const [isTimeActive, setIsTimeActive] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  // const checkActiveTime = async () => {
  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/api/Provider/get-time-active-available`)
  //     .then((res) => {
  //       const timeStart = res?.data?.data.timeFrom;
  //       const timeEnd = res?.data?.data.timeTo;
  //       const currentHour = dayjs().format('H:mm:ss');

  //       const isTimeBetween = dayjs(`2016-01-01 ${currentHour}`).isBetween(
  //         `2016-01-01 ${timeStart}`,
  //         `2016-01-01 ${timeEnd}`,
  //         `millisecond`,
  //         `[)`,
  //       );
  //       // const isTimeBetween = dayjs(`2016-01-01 ${currentHour}`).isBetween(`2016-01-01 1:00:00`, `2016-01-01 2:00:00`, `millisecond`, `[)`);

  //       setIsTimeActive(isTimeBetween);
  //     });
  // };

  // useEffect(() => {
  //   checkActiveTime();
  // }, []);

  const onFinish = async (values: any) => {
    const config = {
      headers: {
        requestId: uuidv4(),
        deviceId: localStorage.getItem('deviceId') || '',
      },
    };
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_IAM_URL}/api/v1/auth/login`,
        { ...values, appCode: 'TELCO_NPP' },
        config,
      )
      .then(async (res) => {
        if (res?.data?.data) {
          try {
            const token = res?.data?.data.accessToken;
            const refreshToken = res?.data?.data?.refreshToken;
            const tokenType = res?.data?.data.tokenScheme;
            localStorage.setItem('token', token.toString());
            localStorage.setItem('isKHDN', 'KHDN');
            localStorage.setItem('refreshToken', refreshToken.toString());
            localStorage.setItem('tokenType', tokenType.toString());
            const resMerchant = await getMerchant();
            const pmsRes = await getAccountInfo();
            const resMasterDataSubType = await getMasterData({ code: 'subType' });
            const resMasterDataDocuments = await getMasterData({ code: 'documents' });

            const resMasterDataSimMode = await getSimMode();

            if (resMerchant) {
              localStorage.setItem('merchantInfo', JSON.stringify(resMerchant));
            }
            if (pmsRes && resMasterDataSubType) {
              store.dispatch(
                setGlobalState({
                  masterData: {
                    ...masterData,
                    pms: filterEnabledNodes(pmsRes.results ?? []),
                    subType: resMasterDataSubType,
                    documents:
                      resMasterDataDocuments && resMasterDataDocuments[0].description
                        ? JSON.parse(resMasterDataDocuments[0].description)
                        : [],
                    simMode: resMasterDataSimMode,
                  },
                }),
              );
            }
            navigate('/management');
          } catch (error) {
            console.log('🚀 ~ onFinish login ~ error:', error);
            message.error('Đăng nhập không thành công, vui lòng thử lại');
          }
        } else {
          axios
            .post(
              `${process.env.REACT_APP_AUTH_SSO_URL}/auth-service/v1/login`,
              { ...values, appCode: 'TELCO' },
              config,
            )
            .then((res) => {
              if (res?.data?.response) {
                const token = res?.data?.response.accessToken;
                const refreshToken = res?.headers?.refreshtoken;
                const tokenType = res?.data?.response.tokenType;
                localStorage.setItem('isKHDN', 'NPP');
                localStorage.setItem('token', token.toString());
                localStorage.setItem('refreshToken', refreshToken.toString());
                localStorage.setItem('tokenType', tokenType.toString());
                navigate('/');
              } else {
                if (res?.data?.errorMessage === 'Error') {
                  message.error('Tài khoản và mật khẩu không trùng khớp');
                }
              }
            });
        }
      })
      .catch((err) => {
        console.log(err);
        message.error({
          content: err.response?.data?.message,
          style: {
            top: '50%',
          },
        });
      })
      .finally(() => setLoading(false));
  };

  //   const login = async (values: any) => {
  //     axios
  //       .post(`${process.env.REACT_APP_KHDN_AUTH_URL}/api/user/get-tokens`, values)
  //       .then((res) => {
  //         const token = res.headers.accesstoken;
  //         const role = res.headers.role;
  //         const merchantInfo = res?.data?.body;
  //         localStorage.setItem('merchantInfo', JSON.stringify({ ...merchantInfo, role }));
  //         localStorage.setItem('token', token.toString());

  //         if (role === 'MERCHANT_KHDN') {
  //           navigate('/management');
  //         } else {
  //           message.error('Tài khoản chưa đăng ký');
  //           return;
  //         }
  //       })
  //       .catch((err) =>
  //         message.error({
  //           content: err.response?.data?.message,
  //           style: {
  //             top: '50%',
  //           },
  //         }),
  //       )
  //       .finally(() => setLoading(false));
  //   };

  return (
    <div className='w-screen h-screen wrapper'>
      <div className='p-6 login-form'>
        <Form onFinish={onFinish}>
          <h4 className='text-center'>Đăng nhập</h4>
          <Form.Item
            name='username'
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập tên tài khoản!',
              },
            ]}
            className={'w-full'}
          >
            <Input
              prefix={<UserOutlined className='site-form-item-icon' />}
              placeholder='Nhập tên tài khoản'
              className='text_area'
            />
          </Form.Item>
          <Form.Item
            name='password'
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập mật khẩu!',
              },
            ]}
            className={'mt-2 w-full'}
          >
            <Input
              prefix={<LockOutlined className='site-form-item-icon' />}
              type={showPassword ? 'text' : 'password'}
              suffix={
                <button
                  type='button'
                  onClick={handleShowPassword}
                  className='cursor-pointer text-gray-400 hover:text-gray-600 border-0 bg-transparent p-0'
                >
                  {showPassword ? (
                    <AiOutlineEye size={20} className='text-gray-400 hover:text-gray-600' />
                  ) : (
                    <AiOutlineEyeInvisible
                      size={20}
                      className='text-gray-400 hover:text-gray-600'
                    />
                  )}
                </button>
              }
              placeholder='Mật khẩu'
              className='text_area'
            />
          </Form.Item>

          <Form.Item className=' w-full flex justify-center mt-6'>
            <Button
              loading={loading}
              type='primary'
              htmlType='submit'
              className='btn-submit bg-[#1677ff]'
            >
              Đăng nhập
            </Button>
          </Form.Item>
          <div className='w-full flex justify-center mt-3'>
            <Button
              type='link'
              className='text-sm text-gray-600 hover:text-[#1677ff]'
              onClick={() => navigate('/forgot-password')}
            >
              Quên mật khẩu?
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default Login;
